import React, { useMemo, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// Tabla de indicadores agrupada por responsable — colapsable: click en la fila del responsable
// despliega sus clientes/números asociados (mdl_Mensajeria_Indicadores_Detalle, plano, trae
// idresponsable/Responsable repetido por cada cliente). Sin navegación: solo expande/colapsa,
// mismo patrón de ReporteVisitasTabla (CRM) pero sin salir de la pantalla.
export const MensajeriaIndicadoresTabla = ({ listado }) => {
    const [abiertos, setAbiertos] = useState({});

    const toggle = (idresponsable) => {
        setAbiertos((prev) => ({ ...prev, [idresponsable]: !prev[idresponsable] }));
    };

    // Los porcentajes nunca deben rebasar 100 (ej. recibidos > enviados por reenvíos/históricos)
    const topePct = (n) => Math.min(100, Math.max(0, n));

    // Sin recibidos pero con respuestas enviadas (ej. respuesta libre) cuenta como 100%
    const pctGrupo = (grupo) => {
        if (grupo.recibidos > 0) return topePct(Math.round((grupo.enviados / grupo.recibidos) * 100));
        return grupo.enviados > 0 ? 100 : 0;
    };

    const responsablesAgrupados = useMemo(() => {
        const grupos = new Map();
        (listado || []).forEach((c) => {
            if (!grupos.has(c.idresponsable)) {
                grupos.set(c.idresponsable, {
                    idresponsable: c.idresponsable,
                    responsable: c.responsable,
                    sucursal: c.sucursal,
                    clientes: [],
                    recibidos: 0,
                    enviados: 0,
                });
            }
            const grupo = grupos.get(c.idresponsable);
            grupo.clientes.push(c);
            grupo.recibidos += c.recibidos || 0;
            grupo.enviados += c.enviados || 0;
        });
        // Primero el asesor con mayor % de respuesta; empate por cantidad de enviados, luego nombre
        return [...grupos.values()].sort(
            (a, b) =>
                pctGrupo(b) - pctGrupo(a) ||
                b.enviados - a.enviados ||
                (a.responsable || "").localeCompare(b.responsable || "", "es")
        );
    }, [listado]);

    return (
        <div className="mjr-ind-tabla-wrap scroll">
            <table className="mjr-ind-tabla">
                <thead>
                    <tr>
                        <th>Responsable</th>
                        <th>Sucursal</th>
                        <th>Recibidos</th>
                        <th>Enviados</th>
                        <th>% Resp.</th>
                    </tr>
                </thead>
                <tbody>
                    {responsablesAgrupados.map((grupo) => {
                        const expandido = !!abiertos[grupo.idresponsable];
                        return (
                            <React.Fragment key={grupo.idresponsable}>
                                <tr className="mjr-ind-fila-responsable" onClick={() => toggle(grupo.idresponsable)}>
                                    <td className="mjr-ind-tabla-nombre">
                                        <span className="mjr-ind-flecha">
                                            {expandido ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                                        </span>
                                        {grupo.responsable}
                                    </td>
                                    <td className="mjr-ind-tabla-sucursal">{grupo.sucursal}</td>
                                    <td>{grupo.recibidos}</td>
                                    <td>{grupo.enviados}</td>
                                    <td className="mjr-ind-tabla-pct">{pctGrupo(grupo)}%</td>
                                </tr>

                                {expandido && grupo.clientes.map((c, index) => (
                                    <tr key={`${grupo.idresponsable}-${c.telefono}-${index}`} className="mjr-ind-fila-cliente">
                                        <td className="mjr-ind-tabla-cliente">
                                            <span className="mjr-ind-cliente-nombre">{c.cliente || "Sin nombre"}</span>
                                            <span className="mjr-ind-cliente-telefono">{c.telefono}</span>
                                        </td>
                                        <td className="mjr-ind-tabla-sucursal">{c.linea}</td>
                                        <td>{c.recibidos}</td>
                                        <td>{c.enviados}</td>
                                        <td className="mjr-ind-tabla-pct">
                                            {c.recibidos > 0 ? topePct(c.pct_atencion) : (c.enviados > 0 ? 100 : 0)}%
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        );
                    })}

                    {responsablesAgrupados.length === 0 && (
                        <tr>
                            <td colSpan={5} className="mjr-ind-tabla-vacio">Sin datos para el periodo/filtros seleccionados.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
